export default __webpack_public_path__ + "17d3632cfb279c822e0964756ebf35dc.svg";